export enum EElementDragReason {
  CREATE = "create",
  MOVE = "move"
}
